<template>
  <div class="bootcamp-materials-reference">
    <div
      class="bootcamp-materials-reference__files"
      v-if="bootcamp.files && bootcamp.files.length && files"
    >
      <h4 class="bootcamp-materials-reference__subtitle">Files</h4>
      <div
        v-for="(file, key) in files"
        :key="`file-${key}`"
        class="bootcamp-materials-reference__panel"
      >
        <span class="bootcamp-materials-reference__panel--type">{{
          file.type
        }}</span>
        <a
          href="#"
          @click.prevent="download(file)"
          class="bootcamp-materials-reference__panel--name"
          >{{ file.name }}</a
        >
        <a
          href="#"
          @click.prevent="download(file)"
          class="bootcamp-materials-reference__panel--action"
          v-if="!loadingDownload[file.id]"
          >Download</a
        >
        <ActionLoader
          v-if="loadingDownload[file.id]"
          loaderClass="bootcamp-materials-reference__panel--action"
          name="ball-clip-rotate"
        />
      </div>
    </div>
    <div
      class="bootcamp-materials-reference__links"
      v-if="bootcamp.links && bootcamp.links.length"
    >
      <h4 class="bootcamp-materials-reference__subtitle">Useful links</h4>
      <div
        v-for="(link, key) in bootcamp.links"
        :key="`file-${key}`"
        class="bootcamp-materials-reference__panel"
      >
        <span class="bootcamp-materials-reference__panel--type">
          <span class="material-icons">
            link
          </span>
        </span>
        <a
          :href="link.url"
          rel="noopener nofollow"
          target="_blank"
          class="bootcamp-materials-reference__panel--name"
          >{{ link.name }}</a
        >
        <a
          :href="link.url"
          rel="noopener nofollow"
          target="_blank"
          class="bootcamp-materials-reference__panel--action"
          >Open Link</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'ReferenceMaterials',
  components: {
    ActionLoader,
  },
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    files: {
      type: Object,
      required: false,
    },
  },
  data: () => {
    return {
      loadingDownload: {},
    }
  },
  methods: {
    async download(file) {
      this.$set(this.loadingDownload, file.id, true)
      const response = await this.$store.dispatch(
        'files/getFileDownloadLink',
        file.id
      )
      this.$delete(this.loadingDownload, file.id)
      const anchor = document.createElement('a')
      anchor.href = response.download_url
      anchor.download = response.filename
      anchor.click()
    },
  },
}
</script>

<style lang="scss">
.bootcamp-materials-reference {
  &__subtitle {
    font-size: rem(18px);
    color: var(--orange);
    text-transform: uppercase;
    margin: 25px 0;
  }
  &__panel {
    background: var(--darker-gray);
    padding: 25px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    @include desktop {
      padding: 0px 25px;
      height: 65px;
    }
    &--type {
      color: var(--orange);
      font-size: rem(16px);
      text-transform: uppercase;
      margin: 0 15px 0 0;
      @include desktop {
        margin: 0 25px 0 0;
      }
    }
    &--action {
      color: var(--white);
      text-decoration: underline;
      font-size: rem(16px);
      margin: 0 0 0 auto;
    }
    &--name {
      color: var(--white);
      text-decoration: underline;
      font-size: rem(16px);
      margin: 0 auto;
      max-width: 250px;
      @include mobile {
        max-width: 100%;
      }
    }
    .action-loader {
      margin-left: auto;
      padding-right: 40px;
    }
  }
}
</style>
